export const VIEW_LOADING = 'VIEW_LOADING';
export const VIEW_LOADED = 'VIEW_LOADED';
export const VIEW_UNLOADED = 'VIEW_UNLOADED';
export const VIEW_INITIATED = 'VIEW_INITIATED';